module.exports = __webpack_public_path__ + "static/media/indus4.094f5cc6.jpg";